import { useState } from "react";
import { toast } from "sonner";
import api from "@/lib/api";
import { MapPin, Mail, Instagram, Facebook } from "lucide-react";

export default function Contatti() {
  const [form, setForm] = useState({ name: "", email: "", subject: "", message: "" });
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await api.post("/contact", { ...form, kind: "generic" });
      toast.success("Messaggio inviato! Ti rispondiamo presto.");
      setForm({ name: "", email: "", subject: "", message: "" });
    } catch { toast.error("Errore invio"); }
    finally { setLoading(false); }
  };

  const input = "w-full rounded-xl bg-white border border-[#292522]/12 px-4 py-3 focus:border-[#FF6100] focus:ring-2 focus:ring-[#FF6100]/20 outline-none text-sm";

  return (
    <div data-testid="contatti-page">
      <section className="bg-[#FFF1E8] py-16">
        <div className="container-vv">
          <div className="eyebrow">Contatti</div>
          <h1 className="mt-4 font-display font-medium text-5xl sm:text-6xl tracking-tight text-[#292522]">Facciamoci due chiacchiere</h1>
          <p className="mt-4 text-lg text-[#292522]/75 max-w-3xl">Domande, curiosità, proposte, semplice desiderio di conoscerci: scrivi pure.</p>
        </div>
      </section>

      <section className="container-vv py-16 grid lg:grid-cols-12 gap-10">
        <div className="lg:col-span-5">
          <h2 className="font-display text-3xl font-medium">Dove ci trovi</h2>
          <div className="mt-6 space-y-4 text-[#292522]/85">
            <div className="flex gap-3"><MapPin className="h-5 w-5 text-[#FF6100] shrink-0 mt-1" strokeWidth={1.75} /><div>Vola Vola APS<br />Via Galliera 2/A<br />40013 Castel Maggiore (BO)</div></div>
            <div className="flex gap-3"><Mail className="h-5 w-5 text-[#FF6100] shrink-0 mt-1" strokeWidth={1.75} /><a href="mailto:volavolaaps@gmail.com" className="hover:text-[#FF6100]" data-testid="contact-email">volavolaaps@gmail.com</a></div>
          </div>
          <div className="mt-6 flex gap-2">
            <a href="#" aria-label="Instagram" className="h-10 w-10 rounded-full bg-[#FFF1E8] hover:bg-[#FF6100] hover:text-white flex items-center justify-center transition-colors"><Instagram className="h-5 w-5" strokeWidth={1.5} /></a>
            <a href="#" aria-label="Facebook" className="h-10 w-10 rounded-full bg-[#FFF1E8] hover:bg-[#FF6100] hover:text-white flex items-center justify-center transition-colors"><Facebook className="h-5 w-5" strokeWidth={1.5} /></a>
          </div>
          <div className="mt-8 rounded-3xl overflow-hidden h-64 border border-[#292522]/8">
            <iframe title="Vola Vola APS · Via Galliera 2/A, Castel Maggiore (BO)" src="https://maps.google.com/maps?q=Via%20Galliera%202%2FA%2C%2040013%20Castel%20Maggiore%20BO&t=m&z=16&output=embed&iwloc=near" className="w-full h-full border-0" loading="lazy" referrerPolicy="no-referrer-when-downgrade" />
          </div>
          <a
            href="https://www.google.com/maps/dir/?api=1&destination=Via+Galliera+2%2FA%2C+40013+Castel+Maggiore+BO"
            target="_blank"
            rel="noopener noreferrer"
            className="mt-3 inline-flex items-center gap-1.5 text-sm font-semibold text-[#FF6100] hover:text-[#D94F00]"
            data-testid="directions-link"
          >
            Apri le indicazioni →
          </a>
        </div>
        <div className="lg:col-span-7 card-vv p-8 bg-[#F8F1E8]">
          <h2 className="font-display text-3xl font-medium">Scrivici</h2>
          <form onSubmit={submit} className="mt-6 space-y-4" data-testid="contact-form">
            <div className="grid sm:grid-cols-2 gap-4">
              <input required placeholder="Nome" className={input} value={form.name} onChange={(e) => setForm({ ...form, name: e.target.value })} data-testid="contact-name" />
              <input required type="email" placeholder="Email" className={input} value={form.email} onChange={(e) => setForm({ ...form, email: e.target.value })} data-testid="contact-form-email" />
            </div>
            <input placeholder="Oggetto (facoltativo)" className={input} value={form.subject} onChange={(e) => setForm({ ...form, subject: e.target.value })} data-testid="contact-subject" />
            <textarea required rows="5" placeholder="Il tuo messaggio…" className={input + " resize-none"} value={form.message} onChange={(e) => setForm({ ...form, message: e.target.value })} data-testid="contact-message" />
            <button type="submit" disabled={loading} className="btn-primary" data-testid="contact-submit">{loading ? "Invio…" : "Invia messaggio"}</button>
          </form>
        </div>
      </section>
    </div>
  );
}
